/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import { Box, Accordion, AccordionSummary, AccordionDetails, Theme, Link } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getMaterials } from '../../../api'
import { propsAction } from '../../../store/props'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const Materials: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  const classes = useStyles()

  const [materials, setMaterials] = useState<any>({
    data: [],
    show: false,
  })

  const handleChangeExMaterials = (show: boolean) => {
    setMaterials({ ...materials, show })
  }

  useEffect(() => {
    getMaterials().then((res) => {
      const { status = 0 } = res
      if (status === 1) setMaterials({ ...materials, data: res.data.material })
    })
  }, [])

  return (
    <Box className={classes.materials}>
      <Accordion
        id="materials"
        expanded={materials.show}
        onChange={() => handleChangeExMaterials(!materials.show)}
        square={false}
      >
        <AccordionSummary expandIcon={<Icon className={className} img={img} />}>Материалы Кубка</AccordionSummary>
        <AccordionDetails>
          <Box className={className.contentAccordionDetails}>
            {materials.data.map((item: any, index: number) => {
              return (
                <Box key={`materials${index}`} mt={item.id === 1 ? 1 : 0} mb={1}>
                  <Link href={item.url} target="_blank" className={classes.link}>
                    {item.title}
                  </Link>
                </Box>
              )
            })}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  materials: {},
  link: {
    fontSize: 18,
    fontWeight: 500,
    transition: '0.2s',
    [down('md')]: {
      fontSize: 16,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  icon: {},
}))
